




















import Vue from 'vue';
import CandidateService from '~/services/CandidateService';
import DialogService from '~/services/DialogService';
import { CandidateJobBuilderChangeEvent, commonProps, setupBuilder } from '~/utils/candidate';
import { CandidateJobBuilder } from '~/utils/candidate/CandidateJobBuilder';
import {
    CandidateProfileScorer,
    CandidateProfileStatus,
} from '~/utils/candidate/CandidateProfileScorer';
import InfoBox from '../components/InfoBox.vue';
import PersonalOverviewForm from '../forms/PersonalOverviewForm.vue';
import PersonalPreferencesForm from '../forms/PersonalPreferencesForm.vue';
import ProfileModal from './ProfileModal.vue';

export default Vue.extend({
    name: 'PersonalDetailsModal',
    components: {
        ProfileModal,
        InfoBox,
        PersonalOverviewForm,
        PersonalPreferencesForm,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },

        ...commonProps(),
    },
    data() {
        return {
            builder: null as CandidateJobBuilder | null,
            service: new CandidateService(),

            newAvatar: null as File | null,
            isLoading: false,

            hasUnsavedChanges: false,
        };
    },
    methods: {
        handleBuilderChange(evt: CandidateJobBuilderChangeEvent) {
            this.hasUnsavedChanges = !evt.empty || !!this.newAvatar;
        },
        handleAvatarChange(file: File) {
            this.hasUnsavedChanges = true;
            this.newAvatar = file;
        },
        async handleSave() {
            if (!this.builder || (this.builder.isEmpty() && !this.newAvatar)) return;

            let scorer: CandidateProfileScorer | null = null;
            let shouldShowIncompleteProfileDialog = false;
            if (this.builder.getCandidateOperation().profileVisibility === 'public_to_recruiters') {
                // Check if the profile is complete to enable "be discovered" mode
                scorer = new CandidateProfileScorer(
                    this.candidate,
                    this.user,
                    this.workAuthorizations
                );
                const score = scorer.getBeDiscoveredScore();
                shouldShowIncompleteProfileDialog =
                    score.status === CandidateProfileStatus.INCOMPLETE;
                if (shouldShowIncompleteProfileDialog) {
                    this.builder.removeCandidateFieldFromOp('profileVisibility');
                }
            }

            const request = this.builder.buildRequest();
            this.isLoading = true;
            await this.service
                .updateCandidateProfile(request, this.newAvatar)
                .then(() => {
                    if (shouldShowIncompleteProfileDialog) {
                        DialogService.openMyProfileBeDiscoveredDialog(scorer);
                    }
                    this.$emit('close');
                })
                .finally(() => (this.isLoading = false));

            this.newAvatar = null;
            this.builder.reset();
        },
        handleClose() {
            this.$emit('close');
        },
    },
    mounted() {
        const builder = setupBuilder.apply(this);
        builder.on('change', this.handleBuilderChange);
    },
    beforeDestroy() {
        if (this.builder) this.builder.off('change', this.handleBuilderChange);
    },
});
